import { fetchWithAuth } from "../../utils/fetchWithAuth";
import { getStudyApiBaseUrl } from "../../config/apiBaseUrls";

export const getWetReadsForQuery = async (modalityId) => {
  const url = new URL(`${getStudyApiBaseUrl()}/api/Study/GetWetRead`);
  const response = await fetchWithAuth(url, {
    method: "POST",
    body: JSON.stringify({
      modalityId: modalityId,
    }),
  });
  const data = await response.json();
  console.log("GET wet reads data", data);
  return data.payload;
};
